// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1OKFj","spin":"Spinner_spin__2TcWv"};